import React, { Component } from 'react'
import { ConnectedRouter } from 'react-router-redux'
import { Switch, Route, Redirect } from 'react-router'
import { HashRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { AlertHandler } from 'components/core'
import { NoContentBox } from 'components/basic'
import { Header, Sidebar, OfflineIndicator } from 'projects/flow-gui-installation/components/core'
import { Installation } from 'config'
import { loadSettings } from './config/loadSettings'
import history from 'store/history'
import http from 'API/http'
import { notify } from 'helpers'
import API from 'API'
import Routes from 'routes'
import { FourOhFour } from 'views/core'
import { default as swal } from 'sweetalert2'
import LoginPage from './login.js'

class Flow extends Component {
  constructor (props) {
    super(props)
    this.state = {
      connected: true,
      loading: true
    }
    this.resizedDimensions = this.resizedDimensions.bind(this)
    window.addEventListener('resize', this.resizedDimensions)
    this.pingInterval = null
  }
  resizedDimensions () {
    if (window.innerWidth <= Installation.collapsegui) {
      this.props.dispatch({type: 'SET_SIDEBAR_STATE', payload: false})
    }
    if (window.innerWidth <= Installation.collapsegui) {
      return this.props.dispatch({type: 'SET_MOBILE_STATE', payload: true})
    }
    if (this.props.siteReducer.isMobile) this.props.dispatch({type: 'SET_MOBILE_STATE', payload: false})
  }

  async componentDidMount () {
    await loadSettings().then(() => {
      this.setState({ loading: false })
    }).catch(() => {
      this.setState({ error: true, loading: false })
    })

    if (this.state.loading === false) {
      document.title = Installation.systemName
      this.resizedDimensions()
      this.pingInterval = setInterval(e => this.ping(), 15000)
      var err, res
      if (window.location.hash.split('/')[3] === 'fakeip') {
        [err, res] = await http.get('access/?testaddressid=' + window.location.hash.split('/')[2])
      } else {
        [err, res] = await http.get('access/')
      }
      if (err && res.cause) {
        return swal(res.cause, '', 'error').then(e => window.location.reload())
      }
      res.data = res.data || {}
      if (res.data.verified) {
        console.log(Installation)
        if (!Installation.portalURL) return notify.alert('This address is already verified', '', 'success')
        return (window.location.href = Installation.portalURL)
      }
      if (!res.data.accessPort || res.data.accessPort === null || res.data.accessPort === 0) {
        this.setState({retry: 10})

        this.retryTimer = setInterval(() => {
          let retry = this.state.retry
          retry--
          if (!retry || retry === 0) {
            clearInterval(this.retryTimer)
            delete this.retryTimer
            window.location.reload()
          }
          this.setState({retry: retry})
        }, 1000)
        res = null
      }

      API.dispatch({
        'SET_ACCESS': res.data || {}
      })
    }
  }
  componentWillUnmount () {
    window.removeEventListener('resize', this.resizedDimensions)
    clearInterval(this.pingInterval)
    if (this.retryTimer) {
      clearInterval(this.retryTimer)
    }
  }
  componentDidUpdate () {
    document.title = Installation.systemName + ' - ' + this.props.siteReducer.pageTitle
  }
  async ping () {
    var [err] = await http.ping('ping')
    if (err) return this.setState({connected: false})
    if (!this.state.connected) {
      window.location.hash = '/installation'
      window.location.reload()
    }
  }
  render () {
    if (!this.props.siteReducer.access || this.state.loading) {
      let text = 'We are detecting your location, please wait.'
      if (this.state.retry) {
        text = 'We could not detect your location, retrying in ' + this.state.retry + ' seconds'
      }
      if (this.state.loading) {
        text = 'Loading.'
      }
      return (
        <div className='content-wrapper flexbox-absolute-center'>
          <div className='text-center'>
            <NoContentBox icon='clock-o' text={text} />
            <i className='fa fa-cog fa-spin' />
          </div>
        </div>)
    }
    if (!this.props.siteReducer.auth.username) {
      return <LoginPage />
    }
    return (
      <div className={'site-wrapper ' + (this.props.siteReducer.sidebar ? 'sidebar-active' : 'sidebar-hidden')}>
        <Header />
        <div className='wrapper'>
          <Sidebar />
          <ConnectedRouter history={history}>
            <HashRouter basename='/'>
              <Switch>
                <Route exact path='/' render={() => {
                  return <Redirect to='/installation' />
                }} />
                {Routes.map(route => <Route key={route.path} exact={route.exact} path={route.path} component={route.component} />)}
                <Route component={FourOhFour} />
              </Switch>
            </HashRouter>
          </ConnectedRouter>
        </div>
        <OfflineIndicator connected={this.state.connected} />
        <AlertHandler />
      </div>
    )
  }
}
// eslint-disable-next-line
Flow = connect(state => state)(Flow)
export default Flow



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/entry.js